import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
import { Link, useLocation } from 'react-router-dom';
import { Shield } from 'lucide-react';

export const Header = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 sm:gap-3" data-testid="logo-link">
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#009639] flex items-center justify-center">
              <span className="text-white font-serif font-bold text-base sm:text-lg">U</span>
            </div>
            <div>
              <h1 className="text-white font-serif text-sm sm:text-lg font-semibold">theuaeis.com</h1>
              <p className="text-white/60 text-xs hidden sm:block">{t('tagline')}</p>
            </div>
          </Link>

          <div className="flex items-center gap-4">
            <LanguageToggle />
            {!isAdmin && (
              <Link
                to="/admin"
                className="text-white/60 hover:text-white transition-colors p-2 rounded-lg hover:bg-white/5"
                data-testid="admin-link"
                title="Admin"
              >
                <Shield className="w-5 h-5" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
